import { render } from "./PerformanceChart.vue?vue&type=template&id=915ac1c4&scoped=true"
import script from "./PerformanceChart.vue?vue&type=script&lang=js"
export * from "./PerformanceChart.vue?vue&type=script&lang=js"

import "./PerformanceChart.vue?vue&type=style&index=0&id=915ac1c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-915ac1c4"]])

export default __exports__